module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-snackbar', {
    attrs: {
      "color": _vm.snack.color,
      "timeout": _vm.snack.timeout,
      "multi-line": "",
      "top": ""
    },
    model: {
      value: (_vm.snack.visible),
      callback: function($$v) {
        _vm.$set(_vm.snack, "visible", $$v)
      },
      expression: "snack.visible"
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.snack.message) + "\n\t\t"), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.snack.visible = false
      }
    }
  }, [_vm._v("\n\t\t\tClose\n\t\t")])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": "error",
      "timeout": 0,
      "multi-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.limitSnack.visible),
      callback: function($$v) {
        _vm.$set(_vm.limitSnack, "visible", $$v)
      },
      expression: "limitSnack.visible"
    }
  }, [_vm._v("\n\t\tDevice limit exceeded."), _c('br'), _vm._v("The devices are blocked until you reduce their number to fit into the limit.\n\t\t"), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.limitSnack.visible = false
      }
    }
  }, [_vm._v("\n\t\t\tClose\n\t\t")])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bottom-to-top"
    }
  }, [(_vm.selectedDevices.length) ? _c('div', {
    staticClass: "v-dialog__content v-dialog__content--active",
    staticStyle: {
      "z-index": "202",
      "height": "auto",
      "bottom": "0"
    },
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "v-dialog v-bottom-sheet v-dialog--active v-dialog--persistent devices__group-bottom-sheet"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "fill-height": "",
      "justify-space-between": ""
    }
  }, [_c('div', {
    staticClass: "devices__selected-text"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.selectedDevices.length) + " device"), _c('span', {
    attrs: {
      "hidden": _vm.selectedDevices.length < 2
    }
  }, [_vm._v("s")]), _vm._v(" selected\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    class: {
      'devices__group-bottom-sheet__small-screen': _vm.windowSize.width <= 650
    }
  }, [_c('v-menu', {
    attrs: {
      "top": "",
      "offset-x": "",
      "close-on-click": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "large": "",
            "text": "",
            "color": "black",
            "disabled": _vm.groups.length === 0
          }
        }, on), [_vm._v("\n\t\t\t\t\t\t\t\t\tMove to group\n\t\t\t\t\t\t\t\t")])]
      }
    }], null, false, 1764587401)
  }, [_vm._v(" "), _c('v-list', [_vm._l((_vm.groups), function(item, index) {
    return _c('v-list-item', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.addSelectedDevicesToGroup(item.ID)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(item.Name))])], 1)
  }), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.addSelectedDevicesToGroup(0)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("All devices")])], 1)], 2)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "large": "",
      "type": "button",
      "color": "primary",
      "to": {
        name: 'new-group-modal',
        params: {
          credential: _vm.selectedDevicesID,
          filter: _vm.currentFilter
        }
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tNew group\n\t\t\t\t\t\t")])], 1)])], 1)]) : _vm._e()]), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.errorSnack.color,
      "timeout": _vm.errorSnack.timeout,
      "top": "",
      "multi-line": ""
    },
    model: {
      value: (_vm.errorSnack.visible),
      callback: function($$v) {
        _vm.$set(_vm.errorSnack, "visible", $$v)
      },
      expression: "errorSnack.visible"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.errorSnack.message)
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.errorSnack.visible = false
      }
    }
  }, [_vm._v("\n\t\t\tClose\n\t\t")])], 1), _vm._v(" "), (!_vm.isSetupDeviceRequired) ? [_c('div', {
    staticClass: "devices__header"
  }, [(_vm.showSearch) ? _c('v-layout', {
    staticClass: "devices__title devices__title-multi-line",
    attrs: {
      "justify-space-between": ""
    }
  }, [_c('v-row', {
    staticClass: "devices__header-left",
    attrs: {
      "no-gutters": "",
      "align": "center",
      "justify": "space-between"
    }
  }, [_c('h1', {
    staticClass: "title--general title--1"
  }, [_vm._v("My Devices")]), _vm._v(" "), (_vm.isScreenMonitoringEnabled) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "devices__header-monitoring",
          attrs: {
            "dark": "",
            "color": "white",
            "text": "",
            "ripple": false,
            "to": {
              name: 'screenmonitoring'
            }
          }
        }, on), [_c('svg-icon', {
          staticClass: "icon icon--large icon--white",
          attrs: {
            "icon": "monitoring"
          }
        })], 1)]
      }
    }], null, false, 3391254540)
  }, [_vm._v(" "), _c('span', [_vm._v("Monitoring")])]) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
    staticClass: "devices__header-right",
    attrs: {
      "no-gutters": "",
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "devices__search"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Search",
      "type": "text",
      "hide-details": "",
      "height": "44",
      "prepend-inner-icon": "search",
      "color": "primary",
      "clear-icon": "mdi-close-circle",
      "clearable": "",
      "dark": "",
      "outlined": ""
    },
    on: {
      "input": function($event) {
        _vm.onFilterInput();
        _vm.setTypeing()
      }
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "devices__header-spacer"
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "right-input",
    attrs: {
      "large": "",
      "type": "button",
      "to": {
        name: 'pairing-device'
      },
      "disabled": _vm.isCancelled || !_vm.isPairingEnabled,
      "color": "primary"
    }
  }, [_c('span', {
    staticClass: "devices__add-short"
  }, [_vm._v("Add new")]), _vm._v(" "), _c('span', {
    staticClass: "devices__add-long"
  }, [_vm._v("Pair a new device")])])], 1)], 1) : _c('v-layout', {
    staticClass: "devices__title devices__title-single-line",
    attrs: {
      "justify-space-between": ""
    }
  }, [_c('v-row', {
    staticClass: "devices__header-left",
    attrs: {
      "no-gutters": "",
      "align": "center",
      "justify": "space-between"
    }
  }, [_c('h1', {
    staticClass: "title--general title--1"
  }, [_vm._v("My Devices")]), _vm._v(" "), (_vm.isScreenMonitoringEnabled) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "devices__header-monitoring",
          attrs: {
            "dark": "",
            "color": "white",
            "text": "",
            "ripple": false,
            "to": {
              name: 'screenmonitoring'
            }
          }
        }, on), [_c('svg-icon', {
          staticClass: "icon icon--large icon--white",
          attrs: {
            "icon": "monitoring"
          }
        })], 1)]
      }
    }], null, false, 3391254540)
  }, [_vm._v(" "), _c('span', [_vm._v("Monitoring")])]) : _vm._e()], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "right-input",
    attrs: {
      "large": "",
      "type": "button",
      "to": {
        name: 'pairing-device'
      },
      "disabled": _vm.isCancelled || !_vm.isPairingEnabled,
      "color": "primary"
    }
  }, [_c('span', {
    staticClass: "devices__add-short"
  }, [_vm._v("Add new")]), _vm._v(" "), _c('span', {
    staticClass: "devices__add-long"
  }, [_vm._v("Pair a new device")])])], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.view === 'list') ? _c('div', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: (_vm.onResize),
      expression: "onResize"
    }],
    key: "list"
  }, [_c('v-data-table', {
    directives: [{
      name: "table",
      rawName: "v-table"
    }],
    staticClass: "table table--with-header-shadow",
    attrs: {
      "headers": _vm.computedHeaders,
      "items": _vm.devices,
      "custom-sort": _vm.sortedDevices,
      "must-sort": "",
      "dark": "",
      "hide-default-footer": "",
      "show-select": "",
      "items-per-page": _vm.maxDevicePerPage,
      "item-key": "PublicID",
      "group-by": _vm.shouldGroup,
      "sort-by": "Online",
      "mobile-breakpoint": 0
    },
    scopedSlots: _vm._u([{
      key: "group.header",
      fn: function(props) {
        return [(props.group === 'g0000000000') ? _c('div', {
          staticClass: "devices__group-header devices__group-header-absolute"
        }, [_vm._v("\n\t\t\t\t\t\t\tAll devices\n\t\t\t\t\t\t")]) : (!_vm.groupNames[_vm.getStringIndex(props.group)].Edited) ? _c('div', {
          staticClass: "devices__group-header devices__group-header-absolute",
          on: {
            "click": function($event) {
              return _vm.onEdit(props.group)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.groupNames[_vm.getStringIndex(props.group)].Name) + "\n\t\t\t\t\t\t\t"), _c('svg-icon', {
          staticClass: "icon icon--smaller modify-icon",
          attrs: {
            "icon": "pencil"
          }
        })], 1) : _c('input', {
          directives: [{
            name: "autowidth",
            rawName: "v-autowidth",
            value: ({
              maxWidth: _vm.windowSize.width * 0.878 + 'px',
              minWidth: '20px',
              comfortZone: 0
            }),
            expression: "{maxWidth: windowSize.width*0.878+'px', minWidth: '20px', comfortZone: 0}"
          }, {
            name: "model",
            rawName: "v-model",
            value: (_vm.groupNames[_vm.getStringIndex(props.group)].Name),
            expression: "groupNames[getStringIndex(props.group)].Name"
          }],
          staticClass: "devices__group-header devices__group-header-absolute devices__group-header-input",
          attrs: {
            "id": props.group,
            "type": "text",
            "maxlength": "64",
            "autofocus": ""
          },
          domProps: {
            "value": (_vm.groupNames[_vm.getStringIndex(props.group)].Name)
          },
          on: {
            "focus": function($event) {
              return _vm.saveOldGroupName(props.group)
            },
            "keyup": [function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.saveGroupName(props.group)
            }, function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
              return $event.target.blur()
            }],
            "blur": function($event) {
              return _vm.discardGroupName(props.group)
            },
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(_vm.groupNames[_vm.getStringIndex(props.group)], "Name", $event.target.value)
            }
          }
        })]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_c('tr')]
      },
      proxy: true
    }, {
      key: "body.prepend",
      fn: function(props) {
        return [_c('div', {
          staticClass: "table__header-shadow"
        }), _vm._v(" "), _c('v-progress-linear', {
          staticClass: "table__header-loading-linear",
          attrs: {
            "active": _vm.isSearching,
            "indeterminate": "",
            "height": "2",
            "color": "primary"
          }
        })]
      }
    }, {
      key: "item.DisplayIcon",
      fn: function(props) {
        return [_c('a', {
          staticClass: "link--white table__cell--center table__cell--phone",
          attrs: {
            "href": _vm.getLink(props.item)
          }
        }, [_c('div', {
          staticClass: "phone phone--thumbnail table__phone"
        }, [(props.item.LastConnected) ? _c('img', {
          staticClass: "phone__screen-thumbnail",
          attrs: {
            "src": "/_api/devices/preview?publicid=" + props.item.PublicID,
            "alt": ""
          }
        }) : _vm._e()])])]
      }
    }, {
      key: "item.DisplayName",
      fn: function(props) {
        return [_c('a', {
          staticClass: "link--white table__cell",
          class: {
            'table__cell--secondary': _vm.isDeviceLimitExceeded
          },
          attrs: {
            "href": _vm.getLink(props.item)
          }
        }, [(_vm.windowSize.width <= _vm.list.xs) ? _c('span', [_vm._v(_vm._s(_vm._f("truncate")(props.item.DisplayName, _vm.windowSize.width / 23, '...')))]) : (_vm.windowSize.width <= _vm.list.sm) ? _c('span', [_vm._v(_vm._s(_vm._f("truncate")(props.item.DisplayName, _vm.windowSize.width / 36, '...')))]) : (_vm.windowSize.width <= _vm.list.md) ? _c('span', [_vm._v(_vm._s(_vm._f("truncate")(props.item.DisplayName, _vm.windowSize.width / 44, '...')))]) : (_vm.windowSize.width <= _vm.list.lg) ? _c('span', [_vm._v(_vm._s(_vm._f("truncate")(props.item.DisplayName, _vm.windowSize.width / 59, '...')))]) : (_vm.windowSize.width <= _vm.list.xl) ? _c('span', [_vm._v(_vm._s(_vm._f("truncate")(props.item.DisplayName, _vm.windowSize.width / 71, '...')))]) : _c('span', [_vm._v(_vm._s(props.item.DisplayName))])])]
      }
    }, {
      key: "item.DeviceBrand",
      fn: function(props) {
        return [_c('a', {
          staticClass: "link--white table__cell",
          class: {
            'table__cell--secondary': !props.item.LastConnected || _vm.isDeviceLimitExceeded
          },
          attrs: {
            "href": _vm.getLink(props.item)
          }
        }, [(_vm.windowSize.width <= _vm.list.sm) ? _c('span', [_vm._v(_vm._s(_vm._f("truncate")(_vm._f("model")(props.item), _vm.windowSize.width / 36, '...')))]) : (_vm.windowSize.width <= _vm.list.md) ? _c('span', [_vm._v(_vm._s(_vm._f("truncate")(_vm._f("model")(props.item), _vm.windowSize.width / 44, '...')))]) : (_vm.windowSize.width <= _vm.list.lg) ? _c('span', [_vm._v(_vm._s(_vm._f("truncate")(_vm._f("model")(props.item), _vm.windowSize.width / 59, '...')))]) : (_vm.windowSize.width <= _vm.list.xl) ? _c('span', [_vm._v(_vm._s(_vm._f("truncate")(_vm._f("model")(props.item), _vm.windowSize.width / 71, '...')))]) : _c('span', [_vm._v(_vm._s(_vm._f("truncate")(_vm._f("model")(props.item), _vm.windowSize.width / 50, '...')))])])]
      }
    }, {
      key: "item.AccessLevel",
      fn: function(props) {
        return [_c('a', {
          staticClass: "link--white table__cell",
          class: {
            'table__cell--secondary': !props.item.LastConnected || _vm.isDeviceLimitExceeded
          },
          attrs: {
            "href": _vm.getLink(props.item)
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("deviceAccessLevel")(props.item)) + "\n\t\t\t\t\t\t")])]
      }
    }, {
      key: "item.LastConnected",
      fn: function(props) {
        return [_c('a', {
          staticClass: "link--white table__cell",
          class: {
            'table__cell--secondary': !props.item.LastConnected || _vm.isDeviceLimitExceeded
          },
          attrs: {
            "href": _vm.getLink(props.item)
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("lastActivity")(props.item.LastConnected)) + "\n\t\t\t\t\t\t")])]
      }
    }, {
      key: "item.Online",
      fn: function(props) {
        return [(_vm.windowSize.width >= _vm.list.md + 1) ? _c('a', {
          staticClass: "link--white table__cell",
          class: {
            'table__cell--secondary': !props.item.LastConnected || _vm.isDeviceLimitExceeded
          },
          attrs: {
            "href": _vm.getLink(props.item)
          }
        }, [_c('b', {
          staticClass: "badge badge--left",
          class: {
            'badge--offline': !props.item.Online,
              'badge--online': props.item.Online
          }
        }), _vm._v(_vm._s(_vm._f("status")(props.item.Online)) + "\n\t\t\t\t\t\t")]) : _c('a', {
          staticClass: "link--white table__cell--status",
          class: {
            'table__cell--secondary': !props.item.LastConnected || _vm.isDeviceLimitExceeded
          }
        }, [_c('b', {
          staticClass: "badge badge--left",
          class: {
            'badge--offline': !props.item.Online,
              'badge--online': props.item.Online
          }
        }), _vm._v(" "), _c('v-menu', {
          attrs: {
            "bottom": "",
            "left": "",
            "close-on-content-click": false,
            "min-width": "200px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('button', _vm._g({
                staticClass: "dropdown"
              }, on), [_c('v-icon', {
                attrs: {
                  "dark": ""
                }
              }, [_vm._v("more_vert")])], 1)]
            }
          }], null, true),
          model: {
            value: (_vm.dropdowns[_vm.getDropdownindex(props.item.PublicID)].value),
            callback: function($$v) {
              _vm.$set(_vm.dropdowns[_vm.getDropdownindex(props.item.PublicID)], "value", $$v)
            },
            expression: "dropdowns[getDropdownindex(props.item.PublicID)].value"
          }
        }, [_vm._v(" "), _c('v-list', {
          staticClass: "dropdown__open"
        }, [_c('v-list-item-group', [_c('v-list-item', {
          on: {
            "click": function($event) {
              _vm.dropdowns[_vm.getDropdownindex(props.item.PublicID)].value = false;
              _vm.redirectToDevice(props.item)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Screen Mirroring")])], 1), _vm._v(" "), _c('v-list-item', {
          attrs: {
            "to": {
              name: 'device-details-modal',
              params: {
                publicID: props.item.PublicID,
                filter: _vm.currentFilter
              }
            }
          },
          on: {
            "click": function($event) {
              _vm.dropdowns[_vm.getDropdownindex(props.item.PublicID)].value = false
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Details")])], 1), _vm._v(" "), _c('v-list-item', {
          attrs: {
            "to": {
              name: 'new-group-modal',
              params: {
                credential: [props.item.PublicID],
                filter: _vm.currentFilter
              }
            }
          },
          on: {
            "click": function($event) {
              _vm.dropdowns[_vm.getDropdownindex(props.item.PublicID)].value = false
            }
          }
        }, [_c('v-list-item-title', [_vm._v("New Group")])], 1), _vm._v(" "), _c('v-menu', {
          staticClass: "dropdown__submenu dropdown__open",
          attrs: {
            "offset-x": "",
            "open-on-click": "",
            "close-on-click": "",
            "close-on-content-click": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-list-item', _vm._g({
                attrs: {
                  "disabled": _vm.groups.length === 0
                }
              }, on), [_c('v-list-item-title', [_c('v-layout', {
                attrs: {
                  "justify-space-between": ""
                }
              }, [_c('div', [_vm._v("Move To Group")]), _vm._v(" "), _c('v-icon', [_vm._v("chevron_right")])], 1)], 1)], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-list', {
          staticClass: "dropdown__open"
        }, [_vm._l((_vm.groups), function(item, index) {
          return (props.item.GroupID !== item.ID) ? _c('v-list-item', {
            key: index,
            staticClass: "devices__group-item",
            on: {
              "click": function($event) {
                return _vm.addDevicesToGroup(item.ID, [props.item.PublicID])
              }
            }
          }, [_c('v-list-item-title', [_vm._v(_vm._s(item.Name))])], 1) : _vm._e()
        }), _vm._v(" "), (props.item.GroupID !== 0) ? _c('v-list-item', {
          staticClass: "devices__nogroup-item",
          on: {
            "click": function($event) {
              return _vm.addDevicesToGroup(0, [props.item.PublicID])
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Remove")])], 1) : _vm._e()], 2)], 1)], 1)], 1)], 1)], 1)]
      }
    }, {
      key: "item.DropdownIcon",
      fn: function(props) {
        return [_c('div', {
          staticClass: "table__cell--center"
        }, [_c('dropdown', {
          attrs: {
            "model": _vm.dropdowns[_vm.getDropdownindex(props.item.PublicID)],
            "filter": _vm.currentFilter,
            "groupID": props.item.GroupID,
            "groups": _vm.groups,
            "device": props.item
          },
          on: {
            "redirectToDevice": function($event) {
              return _vm.redirectToDevice(props.item)
            },
            "redirectToMap": function($event) {
              return _vm.redirectToDevice(props.item, 'map')
            },
            "redirectToTerminal": function($event) {
              return _vm.redirectToDevice(props.item, 'terminal')
            },
            "redirectToApps": function($event) {
              return _vm.redirectToDevice(props.item, 'apps')
            },
            "redirectToFiles": function($event) {
              return _vm.redirectToDevice(props.item, 'files')
            },
            "addDeviceToGroup": _vm.addDevicesToGroup
          }
        })], 1)]
      }
    }], null, false, 2076477056),
    model: {
      value: (_vm.selectedDevices),
      callback: function($$v) {
        _vm.selectedDevices = $$v
      },
      expression: "selectedDevices"
    }
  })], 1) : _c('div', {
    key: "grid"
  }, [_c('v-progress-circular', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSearching),
      expression: "isSearching"
    }],
    staticClass: "table__header-loading-circular",
    attrs: {
      "size": 70,
      "width": 7,
      "color": "primary",
      "indeterminate": ""
    }
  }), _vm._v(" "), _vm._l((_vm.groups.slice().reverse()), function(group, index) {
    return (_vm.isGroupNotEmpty(group.ID)) ? _c('div', [
      [(!_vm.groupNames[_vm.getStringIndex(_vm.getStringGroupID(group.ID))].Edited) ? _c('div', {
        staticClass: "device-grid__group devices__group-header",
        on: {
          "click": function($event) {
            _vm.onEdit(_vm.getStringGroupID(group.ID))
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.groupNames[_vm.getStringIndex(_vm.getStringGroupID(group.ID))].Name) + "\n\t\t\t\t\t\t\t"), _c('svg-icon', {
        staticClass: "icon icon--smaller modify-icon",
        attrs: {
          "icon": "pencil"
        }
      })], 1) : _c('input', {
        directives: [{
          name: "autowidth",
          rawName: "v-autowidth",
          value: ({
            maxWidth: _vm.windowSize.width * 0.878 + 'px',
            minWidth: '20px',
            comfortZone: 0
          }),
          expression: "{maxWidth: windowSize.width*0.878+'px', minWidth: '20px', comfortZone: 0}"
        }, {
          name: "model",
          rawName: "v-model",
          value: (_vm.groupNames[_vm.getStringIndex(_vm.getStringGroupID(group.ID))].Name),
          expression: "groupNames[getStringIndex(getStringGroupID(group.ID))].Name"
        }],
        staticClass: "device-grid__group devices__group-header devices__group-header-input",
        attrs: {
          "id": _vm.getStringGroupID(group.ID),
          "type": "text",
          "maxlength": "64",
          "autofocus": ""
        },
        domProps: {
          "value": (_vm.groupNames[_vm.getStringIndex(_vm.getStringGroupID(group.ID))].Name)
        },
        on: {
          "focus": function($event) {
            _vm.saveOldGroupName(_vm.getStringGroupID(group.ID))
          },
          "keyup": [function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            _vm.saveGroupName(_vm.getStringGroupID(group.ID))
          }, function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
            return $event.target.blur()
          }],
          "blur": function($event) {
            _vm.discardGroupName(_vm.getStringGroupID(group.ID))
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.groupNames[_vm.getStringIndex(_vm.getStringGroupID(group.ID))], "Name", $event.target.value)
          }
        }
      })], _vm._v(" "), _c('ul', {
        staticClass: "device-grid",
        class: {
          'device-grid--align-left': _vm.haveGroups() && (_vm.windowSize.width > _vm.grid.sd)
        }
      }, [_vm._l((_vm.devices), function(device) {
        return (device.GroupID === group.ID) ? _c('li', {
          staticClass: "device-grid__device device-grid__device--link",
          class: {
            'checked-device': _vm.isDeviceSelected(device),
              'device-grid__device--grouped': _vm.haveGroups()
          }
        }, [_c('ul', [_c('li', [_c('div', {
          staticClass: "device-grid__checkbox"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.selectedDevices),
            expression: "selectedDevices"
          }],
          staticClass: "inp-cbx",
          staticStyle: {
            "display": "none"
          },
          attrs: {
            "id": device.PublicID,
            "type": "checkbox"
          },
          domProps: {
            "value": device,
            "checked": Array.isArray(_vm.selectedDevices) ? _vm._i(_vm.selectedDevices, device) > -1 : (_vm.selectedDevices)
          },
          on: {
            "change": function($event) {
              var $$a = _vm.selectedDevices,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = device,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.selectedDevices = $$a.concat([$$v]))
                } else {
                  $$i > -1 && (_vm.selectedDevices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.selectedDevices = $$c
              }
            }
          }
        }), _vm._v(" "), _c('label', {
          staticClass: "cbx",
          attrs: {
            "for": device.PublicID
          }
        }, [_c('span', [_c('svg', {
          attrs: {
            "width": "12px",
            "height": "10px",
            "viewbox": "0 0 12 10"
          }
        }, [_c('polyline', {
          attrs: {
            "points": "1.5 6 4.5 9 10.5 1"
          }
        })])]), _c('span')])])]), _vm._v(" "), _c('phone', {
          attrs: {
            "device": device,
            "grid": _vm.grid,
            "isDeviceSelected": _vm.isDeviceSelected,
            "redirectToDevice": _vm.redirectToDevice
          }
        }), _vm._v(" "), _c('li', [_c('div', {
          staticClass: "device-grid__dropdown"
        }, [_c('dropdown', {
          attrs: {
            "model": _vm.dropdowns[_vm.getDropdownindex(device.PublicID)],
            "filter": _vm.currentFilter,
            "groupID": device.GroupID,
            "groups": _vm.groups,
            "device": device
          },
          on: {
            "redirectToDevice": function($event) {
              return _vm.redirectToDevice(device)
            },
            "redirectToMap": function($event) {
              return _vm.redirectToDevice(device, 'map')
            },
            "redirectToTerminal": function($event) {
              return _vm.redirectToDevice(device, 'terminal')
            },
            "redirectToApps": function($event) {
              return _vm.redirectToDevice(device, 'apps')
            },
            "redirectToFiles": function($event) {
              return _vm.redirectToDevice(device, 'files')
            },
            "addDeviceToGroup": _vm.addDevicesToGroup
          }
        })], 1)])], 1)]) : _vm._e()
      }), _vm._v(" "), _c('li', {
        class: {
          'device-grid__group--bottom-row': (_vm.haveNotGrouped() || (!_vm.haveNotGrouped() && (index !== (_vm.groups.length - 1)))),
          'device-grid__group--no-bottom-row': !(_vm.haveNotGrouped() || (!_vm.haveNotGrouped() && (index !== (_vm.groups.length - 1))))
        }
      })], 2)
    ], 2) : _vm._e()
  }), _vm._v(" "), (_vm.haveNotGrouped()) ? _c('div', [_c('div', {
    staticClass: "device-grid__group devices__group-header",
    attrs: {
      "hidden": !_vm.haveGroups()
    }
  }, [_vm._v("\n\t\t\t\t\t\tAll devices\n\t\t\t\t\t")]), _vm._v(" "), _c('ul', {
    staticClass: "device-grid",
    class: {
      'device-grid--align-left': _vm.haveGroups() && (_vm.windowSize.width > _vm.grid.sd)
    }
  }, [_vm._l((_vm.devices), function(device) {
    return (device.GroupID === 0) ? _c('li', {
      staticClass: "device-grid__device device-grid__device--link",
      class: {
        'checked-device': _vm.isDeviceSelected(device),
          'device-grid__device--grouped': _vm.haveGroups()
      }
    }, [_c('ul', [_c('li', [_c('div', {
      staticClass: "device-grid__checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedDevices),
        expression: "selectedDevices"
      }],
      staticClass: "inp-cbx",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": device.PublicID,
        "type": "checkbox"
      },
      domProps: {
        "value": device,
        "checked": Array.isArray(_vm.selectedDevices) ? _vm._i(_vm.selectedDevices, device) > -1 : (_vm.selectedDevices)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedDevices,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = device,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedDevices = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedDevices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedDevices = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "cbx",
      attrs: {
        "for": device.PublicID
      }
    }, [_c('span', [_c('svg', {
      attrs: {
        "width": "12px",
        "height": "10px",
        "viewbox": "0 0 12 10"
      }
    }, [_c('polyline', {
      attrs: {
        "points": "1.5 6 4.5 9 10.5 1"
      }
    })])]), _c('span')])])]), _vm._v(" "), _c('phone', {
      attrs: {
        "device": device,
        "grid": _vm.grid,
        "isDeviceSelected": _vm.isDeviceSelected,
        "redirectToDevice": _vm.redirectToDevice
      }
    }), _vm._v(" "), _c('li', [_c('div', {
      staticClass: "device-grid__dropdown"
    }, [_c('dropdown', {
      attrs: {
        "model": _vm.dropdowns[_vm.getDropdownindex(device.PublicID)],
        "filter": _vm.currentFilter,
        "groupID": device.GroupID,
        "groups": _vm.groups,
        "device": device
      },
      on: {
        "redirectToDevice": function($event) {
          return _vm.redirectToDevice(device)
        },
        "redirectToMap": function($event) {
          return _vm.redirectToDevice(device, 'map')
        },
        "redirectToTerminal": function($event) {
          return _vm.redirectToDevice(device, 'terminal')
        },
        "redirectToApps": function($event) {
          return _vm.redirectToDevice(device, 'apps')
        },
        "redirectToFiles": function($event) {
          return _vm.redirectToDevice(device, 'files')
        },
        "addDeviceToGroup": _vm.addDevicesToGroup
      }
    })], 1)])], 1)]) : _vm._e()
  }), _vm._v(" "), (!_vm.isCancelled && !_vm.haveGroups()) ? _c('li', {
    staticClass: "device-grid__device device-grid__device--add"
  }, [_c('button', {
    staticClass: "device-grid__screen device-grid__screen-add",
    attrs: {
      "type": "button"
    }
  }, [_c('router-link', {
    staticClass: "navigation__link",
    attrs: {
      "to": {
        name: 'pairing-device'
      }
    }
  }, [_c('div', {
    staticClass: "phone phone--medium phone--add"
  })])], 1), _vm._v(" "), _c('button', {
    staticClass: "device-grid__info",
    attrs: {
      "type": "button"
    }
  }, [_c('router-link', {
    staticClass: "navigation__link",
    attrs: {
      "to": {
        name: 'pairing-device'
      }
    }
  }, [_c('h2', {
    staticClass: "device-grid__device--add--title"
  }, [_vm._v("Add a new Device")])])], 1)]) : _vm._e()], 2)]) : _vm._e()], 2)])] : [_c('setup-first-device')], _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSwitcher),
      expression: "showSwitcher"
    }],
    staticClass: "view-switcher"
  }, [_c('div', {
    staticClass: "view-switcher__item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.view),
      expression: "view"
    }],
    staticClass: "view-switcher__input",
    attrs: {
      "type": "radio",
      "id": "view-switcher-grid"
    },
    domProps: {
      "value": 'grid',
      "checked": _vm._q(_vm.view, 'grid')
    },
    on: {
      "change": function($event) {
        _vm.view = 'grid'
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "view-switcher__button",
    attrs: {
      "for": "view-switcher-grid"
    }
  }, [_c('svg-icon', {
    staticClass: "view-switcher__icon",
    attrs: {
      "icon": "grid"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "view-switcher__tooltip tooltip tooltip--on-top"
  }, [_vm._v("Grid view")])]), _vm._v(" "), _c('div', {
    staticClass: "view-switcher__item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.view),
      expression: "view"
    }],
    staticClass: "view-switcher__input",
    attrs: {
      "type": "radio",
      "id": "view-switcher-list"
    },
    domProps: {
      "value": 'list',
      "checked": _vm._q(_vm.view, 'list')
    },
    on: {
      "change": function($event) {
        _vm.view = 'list'
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "view-switcher__button",
    attrs: {
      "for": "view-switcher-list"
    }
  }, [_c('svg-icon', {
    staticClass: "view-switcher__icon",
    attrs: {
      "icon": "list"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "view-switcher__tooltip tooltip tooltip--on-top"
  }, [_vm._v("List view")])])]), _vm._v(" "), _c('router-view')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33a47ce2","hasScoped":false}!./app/components/devices/template.html
// module id = 379
// module chunks = 0